module.exports = __webpack_public_path__ + "img/GU.5e65ff1c.png";